// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 676 ? "core_forum" : chunkId) + "." + {"676":"3affcd62","890":"e1be5625"}[chunkId] + ".js";
};